import { render } from "./Customizations.vue?vue&type=template&id=39bfbd0c&ts=true"
import script from "./Customizations.vue?vue&type=script&lang=ts"
export * from "./Customizations.vue?vue&type=script&lang=ts"

import "./Customizations.vue?vue&type=style&index=0&id=39bfbd0c&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__